const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  PUSH_MESSAGES: 'SD/PUSH_MESSAGES',
  PUSH_AUTODIAGNOSTIC_INFO: 'SD/PUSH_AUTODIAGNOSTIC_INFO',
  PUSH_CONTACT_PHONE: 'SD/PUSH_CONTACT_PHONE',
  OPEN_DIAGNOSIS_BEGINS: 'SD/OPEN_DIAGNOSIS',
  OPEN_DIAGNOSIS_SUCCESS: 'SD/OPEN_DIAGNOSIS_SUCCESS',
  OPEN_DIAGNOSIS_FAILURE: 'SD/OPEN_DIAGNOSIS_FAILURE',

  GET_DIAGNOSIS_STATUS_BEGINS: 'SD/GET_DIAGNOSIS_STATUS_BEGINS',
  GET_DIAGNOSIS_STATUS_STOP: 'SD/GET_DIAGNOSIS_STATUS_STOP',
  GET_DIAGNOSIS_STATUS_SUCCESS: 'SD/GET_DIAGNOSIS_STATUS_SUCCESS',
  GET_DIAGNOSIS_STATUS_FAILURE: 'SD/GET_DIAGNOSIS_STATUS_FAILURE',

  SEND_INFO_TO_DIAGNOSIS: 'SD/SEND_INFO_TO_DIAGNOSIS',
  SEND_INFO_TO_DIAGNOSIS_SUCCESS: 'SD/SEND_INFO_TO_DIAGNOSIS_SUCCESS',
  SEND_INFO_TO_DIAGNOSIS_FAILURE: 'SD/SEND_INFO_TO_DIAGNOSIS_FAILURE',

  IS_DIAGNOSIS_OPENED_BEGINS: 'SD/IS_DIAGNOSIS_OPENED_BEGINS',
  IS_DIAGNOSIS_OPENED_SUCCESS: 'SD/IS_DIAGNOSIS_OPENED_SUCCESS',
  IS_DIAGNOSIS_OPENED_FAILURE: 'SD/IS_DIAGNOSIS_OPENED_FAILURE',

  GET_DETAIL_BEGINS: 'GET_DETAIL_BEGINS',
  GET_DETAIL_SUCCESS: 'GET_DETAIL_SUCCESS',
  GET_DETAIL_FAILURE: 'GET_DETAIL_FAILURE',
  GET_DETAIL_CLEAR: 'GET_DETAIL_CLEAR',

  GET_REASON_BEGINS: 'GET_REASON_BEGINS',
  GET_REASON_SUCCESS: 'GET_REASON_SUCCESS',
  GET_REASON_FAILURE: 'GET_REASON_FAILURE',
  GET_REASON_CLEAR: 'GET_REASON_CLEAR',

  PUT_CANCEL_DIAGNOSIS_BEGIN: 'PUT_CANCEL_DIAGNOSIS_BEGIN',
  PUT_CANCEL_DIAGNOSIS_SUCCESS: 'PUT_CANCEL_DIAGNOSIS_SUCCESS',
  PUT_CANCEL_DIAGNOSIS_FAILURE: 'PUT_CANCEL_DIAGNOSIS_FAILURE',
  RESET_CANCEL_DIAGNOSIS: 'RESET_CANCEL_DIAGNOSIS',
  VISIBILITY_CANCEL_DIAGNOSIS: 'VISIBILITY_CANCEL_DIAGNOSIS',

  PUT_REITERATE_DIAGNOSIS_BEGIN: 'PUT_REITERATE_DIAGNOSIS_BEGIN',
  PUT_REITERATE_DIAGNOSIS_SUCCESS: 'PUT_REITERATE_DIAGNOSIS_SUCCESS',
  PUT_REITERATE_DIAGNOSIS_FAILURE: 'PUT_REITERATE_DIAGNOSIS_FAILURE',
  RESET_REITERATE_DIAGNOSIS: 'RESET_REITERATE_DIAGNOSIS',

  PUT_VALIDATE_DIAGNOSIS_BEGIN: 'PUT_VALIDATE_DIAGNOSIS_BEGIN',
  PUT_VALIDATE_DIAGNOSIS_SUCCESS: 'PUT_VALIDATE_DIAGNOSIS_SUCCESS',
  PUT_VALIDATE_DIAGNOSIS_FAILURE: 'PUT_VALIDATE_DIAGNOSIS_FAILURE',
  PUT_NON_VALIDATE_DIAGNOSIS_SUCCESS: 'PUT_NON_VALIDATE_DIAGNOSIS_SUCCESS',
  RESET_VALIDATE_DIAGNOSIS: 'RESET_VALIDATE_DIAGNOSIS',

  PUT_CONTINUE_DIAGNOSIS_BEGIN: 'PUT_CONTINUE_DIAGNOSIS_BEGIN',
  PUT_CONTINUE_DIAGNOSIS_SUCCESS: 'PUT_CONTINUE_DIAGNOSIS_SUCCESS',
  PUT_CONTINUE_DIAGNOSIS_FAILURE: 'PUT_CONTINUE_DIAGNOSIS_FAILURE',
  RESET_CONTINUE_DIAGNOSIS: 'RESET_CONTINUE_DIAGNOSIS',
};

export const actions = {
  pushAutodiagnosticInfo: (issue, child, childs, idCategory) => ({
    type: types.PUSH_AUTODIAGNOSTIC_INFO,
    payload: { issue, child, childs, idCategory },
  }),
  pushPhoneContact: (phoneContact) => ({
    type: types.PUSH_CONTACT_PHONE,
    payload: { phoneContact },
  }),
  pushMessages: (messages, op) => ({
    type: types.PUSH_MESSAGES,
    payload: { messages, op },
  }),

  // OPEN NEW DIAGNOSISS
  openDiagnosis: (data, notification) => ({
    type: types.OPEN_DIAGNOSIS_BEGINS,
    payload: { data },
    notification,
  }),
  openDiagnosisFailure: (error) => ({
    type: types.OPEN_DIAGNOSIS_FAILURE,
    error,
  }),
  openDiagnosisSuccess: (data) => ({
    type: types.OPEN_DIAGNOSIS_SUCCESS,
    payload: { data },
  }),

  // get GET_STATE
  getDiagnosisState: () => ({ type: types.GET_DIAGNOSIS_STATUS_BEGINS }),
  stopDiagnosisState: () => ({ type: types.GET_DIAGNOSIS_STATUS_STOP }),
  getDiagnosisStateFailure: (error) => ({
    type: types.GET_DIAGNOSIS_STATUS_FAILURE,
    error,
  }),
  getDiagnosisStateSuccess: (data) => ({
    type: types.GET_DIAGNOSIS_STATUS_SUCCESS,
    payload: data,
  }),

  // SD SEND INFO
  sendInfoToDiagnosis: (data) => ({
    type: types.SEND_INFO_TO_DIAGNOSIS,
    payload: data,
  }),
  sendInfoToDiagnosisFailure: (error) => ({
    type: types.SEND_INFO_TO_DIAGNOSIS_FAILURE,
    error,
  }),
  sendInfoToDiagnosisSuccess: (data) => ({
    type: types.SEND_INFO_TO_DIAGNOSIS_SUCCESS,
    payload: data,
  }),

  // IS OPEN DIAGNOSIS
  isDiagnosisOpened: (data) => ({
    type: types.IS_DIAGNOSIS_OPENED_BEGINS,
    payload: data,
  }),
  isDiagnosisOpenedSuccess: (data) => ({
    type: types.IS_DIAGNOSIS_OPENED_SUCCESS,
    payload: data,
  }),
  isDiagnosisOpenedFailure: (error) => ({
    type: types.IS_DIAGNOSIS_OPENED_FAILURE,
    payload: error,
  }),

  // GET DETAIL DIAGNOSIS
  getDetailDiagnosis: (data) => ({
    type: types.GET_DETAIL_BEGINS,
    payload: data,
  }),
  getDetailSuccess: (data) => ({
    type: types.GET_DETAIL_SUCCESS,
    payload: data,
  }),
  getDetailFailure: (data) => ({
    type: types.GET_DETAIL_FAILURE,
    payload: data,
  }),
  getDetailClear: () => ({ type: types.GET_DETAIL_CLEAR }),

  // GET REASON DIAGNOSIS
  getReasonDiagnosis: (data) => ({
    type: types.GET_REASON_BEGINS,
    payload: data,
  }),
  getReasonSuccess: (data) => ({
    type: types.GET_REASON_SUCCESS,
    payload: data,
  }),
  getReasonFailure: (data) => ({
    type: types.GET_REASON_FAILURE,
    payload: data,
  }),
  getReasonClear: () => ({ type: types.GET_REASON_CLEAR }),

  // PUT CANCEL DIAGNOSIS
  putCancelDiagnosis: (params) => ({
    type: types.PUT_CANCEL_DIAGNOSIS_BEGIN,
    payload: params,
  }),
  successPutCancelDiagnosis: (data) => ({
    type: types.PUT_CANCEL_DIAGNOSIS_SUCCESS,
    payload: data,
  }),
  failurePutCancelDiagnosis: (error) => ({
    type: types.PUT_CANCEL_DIAGNOSIS_FAILURE,
    payload: error,
  }),
  resetCancelDiagnosis: () => ({ type: types.RESET_CANCEL_DIAGNOSIS }),
  visibilityCancelDiagnosis: () => ({
    type: types.VISIBILITY_CANCEL_DIAGNOSIS,
  }),

  // PUT REITERATE DIAGNOSIS
  putReiterateDiagnosis: (params) => ({
    type: types.PUT_REITERATE_DIAGNOSIS_BEGIN,
    payload: params,
  }),
  successPutReiterateDiagnosis: (data) => ({
    type: types.PUT_REITERATE_DIAGNOSIS_SUCCESS,
    payload: data,
  }),
  failurePutReiterateDiagnosis: (error) => ({
    type: types.PUT_REITERATE_DIAGNOSIS_FAILURE,
    payload: error,
  }),
  resetReiterateDiagnosis: () => ({ type: types.RESET_REITERATE_DIAGNOSIS }),

  // PUT VALIDATE DIAGNOSIS
  putValidateDiagnosis: (params) => ({
    type: types.PUT_VALIDATE_DIAGNOSIS_BEGIN,
    payload: params,
  }),
  successPutValidateDiagnosis: (data) => ({
    type: types.PUT_VALIDATE_DIAGNOSIS_SUCCESS,
    payload: data,
  }),
  successPutNonValidateDiagnosis: (data) => ({
    type: types.PUT_NON_VALIDATE_DIAGNOSIS_SUCCESS,
    payload: data,
  }),
  failurePutValidateDiagnosis: (error) => ({
    type: types.PUT_VALIDATE_DIAGNOSIS_FAILURE,
    payload: error,
  }),
  resetValidateDiagnosis: () => ({ type: types.RESET_VALIDATE_DIAGNOSIS }),

  // PUT CONTINUE DIAGNOSIS
  putContinueDiagnosis: (params) => ({
    type: types.PUT_CONTINUE_DIAGNOSIS_BEGIN,
    payload: params,
  }),
  successPutContinueDiagnosis: (data) => ({
    type: types.PUT_CONTINUE_DIAGNOSIS_SUCCESS,
    payload: data,
  }),
  failurePutContinueDiagnosis: (error) => ({
    type: types.PUT_CONTINUE_DIAGNOSIS_FAILURE,
    payload: error,
  }),
  resetContinueDiagnosis: () => ({ type: types.RESET_CONTINUE_DIAGNOSIS }),
};

export const initialState = {
  /* MAIN USAGE BEGINS */
  comunicationKey: null,
  dialogs: [],
  /* its show blue modal when try leave autoDiagnostic section */
  showWarningWhenLeaving: false,
  /* its allow looping for getStattus */
  looping: false,
  contLooping: {
    cont: 0,
    status: null,
  },
  isOpenDiagnosis: false,
  lastDialogIdReceived: null,
  productIdSelfDiagnosis: null,
  motiveId: null,
  contactNumberSelfDiagnosis: null,
  openDiagnosisFetching: false,
  // INICIAL, DIALOGO_TEXTO, RESPUESTA_DIALOGO_USUARIO, TEST, ACCION, FIN
  conversationState: null,
  /* TRANSACTIONS OPEN DIAGNOSIS */
  openDiagnosisBegins: false,
  openDiagnosisError: false,
  /* transactions GET_STATE */
  pullingUUID: '',
  getDiagnosisStateBegins: false,
  getDiagnosisStateError: false,
  /* trasactions SEND */
  sendDiagnosisInfoBegins: false,
  sendDiagnosisInfoError: false,
  /* PUSH INFO AUTODIAGNOSTIC */
  idCategorySelfDiagnosis: null,
  issue: null,
  child: null,
  phoneContact: null,
  status: null,
  fin: null,
  form: false,
  error: null,
  cp: null,
  childs: null,
  codigoErrorNegocio: null,
  controlErrores: null,

  /* IS DIAGNOSTIC OPENED */
  isDiagnosisOpenedObj: null,
  isDiagnosisOpenedFetching: false,
  isDiagnosisOpenedError: false,

  /* DIAGNOSTIC DETAIL */
  detailDiagnosis: null,
  detailDiagnosisFetching: false,
  detailDiagnosisError: false,

  /* DIAGNOSTIC REASON */
  reasonDiagnosis: null,
  reasonDiagnosisFetching: false,
  reasonDiagnosisError: false,
  reasonDiagnosisReady: false,

  /* CANCEL DIAGNOSIS */
  cancelDiagnosis: null,
  cancelDiagnosisFetching: false,
  cancelDiagnosisError: false,
  cancelDiagnosisModal: false,

  /* REITERATE DIAGNOSIS */
  reiterateDiagnosis: null,
  reiterateDiagnosisFetching: false,
  reiterateDiagnosisError: false,

  /* VALIDATE DIAGNOSIS */
  validateDiagnosis: null,
  validateDiagnosisFetching: false,
  validateDiagnosisError: false,

  /* CONTINUE DIAGNOSIS */
  continueDiagnosis: null,
  continueDiagnosisFetching: false,
  continueDiagnosisError: false,
};

function reducer(state = { ...initialState }, { type, payload, error }) {
  switch (type) {
    case HYDRATE: {
      const { selfDiagnosis } = payload;
      return {
        ...state,
        ...selfDiagnosis,
      };
    }
    /* PUSH INFO AUTODIAGNOSTIC */
    case types.PUSH_CONTACT_PHONE: {
      const { phoneContact } = payload;
      return {
        ...state,
        phoneContact,
      };
    }
    /* PUSH CONTACT PHONE */
    case types.PUSH_AUTODIAGNOSTIC_INFO: {
      const { issue, child, childs, idCategory } = payload;
      return {
        ...state,
        issue,
        child,
        childs,
        idCategorySelfDiagnosis: idCategory,
      };
    }
    /* PUSH MESSAGES */
    case types.PUSH_MESSAGES: {
      const lastMessages = state.dialogs;
      const { op } = payload;
      if (op && op === 'pop') {
        lastMessages.pop();
      }
      if (op && op === 'clean') {
        lastMessages.splice(0, lastMessages.length);
      }

      const newMessages = [...lastMessages, ...payload.messages];

      return {
        ...state,
        dialogs: newMessages.splice(0),
      };
    }
    /* OPEN BEGINS */
    case types.OPEN_DIAGNOSIS_BEGINS: {
      return {
        ...state,
        openDiagnosisBegins: true,
        openDiagnosisError: false,
        isOpenDiagnosis: false,
        openDiagnosisFetching: true,
      };
    }
    case types.OPEN_DIAGNOSIS_SUCCESS: {
      const { data } = payload;
      const {
        comunicationKey,
        newContact,
        lastDialogIdReceived,
        uuid,
        status,
        fin,
        dialogs,
        controlErrores,
        productIdSelfDiagnosis,
        motiveId,
        contactNumberSelfDiagnosis,
        notification,
      } = data;
      let loopingOpen = true;
      if (status === '3') {
        // status 3 usuario ha contestado y esperando a telco
        loopingOpen = !!(dialogs.length > 0 && lastDialogIdReceived);
      } else {
        loopingOpen = !(dialogs.length > 0);
      }

      if (
        status === '6' ||
        status === '2' ||
        status === '7' ||
        status === '8' ||
        notification
      ) {
        loopingOpen = false;
      }

      return {
        ...state,
        dialogs,
        comunicationKey,
        newContact,
        lastDialogIdReceived,
        pullingUUID: uuid,
        looping: loopingOpen,
        openDiagnosisBegins: false,
        openDiagnosisError: false,
        contLooping: {
          cont: 0,
          status: null,
        },
        status,
        fin,
        controlErrores,
        error: false,
        isOpenDiagnosis: true,
        productIdSelfDiagnosis,
        motiveId,
        contactNumberSelfDiagnosis,
        openDiagnosisFetching: false,
      };
    }
    case types.GET_DIAGNOSIS_STATUS_STOP: {
      return {
        ...state,
        looping: false,
        contLooping: {
          cont: 0,
          status: null,
        },
        idCategorySelfDiagnosis: null,
        issue: null,
        child: null,
        phoneContact: null,
        status: null,
        fin: null,
        controlErrores: null,
        lastDialogIdReceived: null,
        error: null,
        openDiagnosisFetching: false,
        dialogs: [],
      };
    }
    case types.OPEN_DIAGNOSIS_FAILURE: {
      const codigoSeguimientoCliente = error
        ? error.codigoSeguimientoCliente
        : null;
      const { codigoErrorNegocio } = error;
      return {
        ...state,
        openDiagnosisBegins: false,
        openDiagnosisError: true,
        error: true,
        cp: codigoSeguimientoCliente,
        codigoErrorNegocio,
        looping: false,
        contLooping: {
          cont: 0,
          status: null,
        },
        isOpenDiagnosis: false,
        openDiagnosisFetching: false,
      };
    }
    /* OPEN ENDS */
    /* GET STATUS BEGINS */
    case types.GET_DIAGNOSIS_STATUS_BEGINS: {
      return {
        ...state,
        getDiagnosisStateBegins: true,
        getDiagnosisStateError: false,
      };
    }
    case types.GET_DIAGNOSIS_STATUS_SUCCESS: {
      /* aquí actualizo el útimo ide recibido y si es distinto quito el loader */
      const data = payload;
      const {
        comunicationKey,
        newContact,
        lastDialogIdReceived,
        uuid,
        status,
        fin,
      } = data;

      const auxContLooping = state.contLooping;
      let loopingStatus = true;
      /* if (status === '6' || dialogs.length > 0) {
        loopingStatus = false;
      } */
      if (
        status === '6' ||
        status === '2' ||
        status === '7' ||
        status === '8'
      ) {
        loopingStatus = false;
        auxContLooping.cont = 0;
        auxContLooping.status = null;
      } else if (status === auxContLooping.status) {
        auxContLooping.cont += 1;
      } else {
        auxContLooping.cont = 1;
        auxContLooping.status = status;
      }

      return {
        ...state,
        comunicationKey,
        newContact,
        lastDialogIdReceived,
        pullingUUID: uuid,
        getDiagnosisStateBegins: false,
        getDiagnosisStateError: false,
        status,
        looping: loopingStatus,
        contLooping: auxContLooping,
        fin,
      };
    }
    case types.GET_DIAGNOSIS_STATUS_FAILURE: {
      const codigoSeguimientoCliente = error
        ? error.codigoSeguimientoCliente
        : null;
      return {
        ...state,
        getDiagnosisStateBegins: false,
        getDiagnosisStateError: true,
        error: true,
        cp: codigoSeguimientoCliente,
        looping: false,
        contLooping: {
          cont: 0,
          status: null,
        },
      };
    }
    /* GET STATUS ENDS */
    /* SEND INFO TO DIAGNOSIS BEGINS */
    case types.SEND_INFO_TO_DIAGNOSIS: {
      return {
        ...state,
        sendDiagnosisInfoBegins: false,
        sendDiagnosisInfoError: false,
        looping: true,
      };
    }
    case types.SEND_INFO_TO_DIAGNOSIS_SUCCESS: {
      return {
        ...state,
        sendDiagnosisInfoBegins: false,
        sendDiagnosisInfoError: false,
        looping: true,
        contLooping: {
          cont: 0,
          status: null,
        },
      };
    }
    case types.SEND_INFO_TO_DIAGNOSIS_FAILURE: {
      const codigoSeguimientoCliente = error
        ? error.codigoSeguimientoCliente
        : null;
      return {
        ...state,
        sendDiagnosisInfoBegins: false,
        sendDiagnosisInfoError: true,
        error: true,
        cp: codigoSeguimientoCliente,
        looping: false,
        contLooping: {
          cont: 0,
          status: null,
        },
      };
    }

    /* SEND INFO TO DIAGNOSIS ENDS */
    case types.IS_DIAGNOSIS_OPENED_BEGINS: {
      return {
        ...state,
        isDiagnosisOpenedFetching: true,
        isDiagnosisOpenedError: false,
      };
    }
    case types.IS_DIAGNOSIS_OPENED_SUCCESS: {
      return {
        ...state,
        isDiagnosisOpenedObj: payload,
        isDiagnosisOpenedFetching: false,
        isDiagnosisOpenedError: false,
      };
    }
    case types.IS_DIAGNOSIS_OPENED_FAILURE: {
      return {
        ...state,
        isDiagnosisOpenedFetching: false,
        isDiagnosisOpenedError: true,
      };
    }
    /* SEND INFO TO DIAGNOSIS ENDS */

    /* GET DETAIL BEGINS */
    case types.GET_DETAIL_BEGINS: {
      return {
        ...state,
        detailDiagnosisFetching: true,
        detailDiagnosisError: false,
      };
    }
    case types.GET_DETAIL_SUCCESS: {
      return {
        ...state,
        detailDiagnosis: payload,
        detailDiagnosisFetching: false,
        detailDiagnosisError: false,
      };
    }
    case types.GET_DETAIL_FAILURE: {
      return {
        ...state,
        detailDiagnosisFetching: false,
        detailDiagnosisError: true,
      };
    }
    /* GET DETAIL ENDS */
    case types.GET_DETAIL_CLEAR: {
      return {
        ...state,
        detailDiagnosis: null,
        detailDiagnosisFetching: null,
        detailDiagnosisError: null,
      };
    }

    case types.GET_REASON_BEGINS: {
      const idCategorySelfDiagnosis = payload;
      return {
        ...state,
        reasonDiagnosis: null,
        reasonDiagnosisFetching: true,
        reasonDiagnosisError: false,
        reasonDiagnosisReady: !!idCategorySelfDiagnosis,
        idCategorySelfDiagnosis,
      };
    }
    case types.GET_REASON_SUCCESS: {
      return {
        ...state,
        reasonDiagnosis: payload,
        reasonDiagnosisFetching: false,
        reasonDiagnosisError: false,
      };
    }
    case types.GET_REASON_FAILURE: {
      return {
        ...state,
        reasonDiagnosis: null,
        reasonDiagnosisFetching: false,
        reasonDiagnosisError: true,
      };
    }

    case types.GET_REASON_CLEAR: {
      return {
        ...state,
        reasonDiagnosis: null,
        reasonDiagnosisFetching: null,
        reasonDiagnosisError: null,
      };
    }

    /* CANCEL DIAGNOSIS */
    case types.PUT_CANCEL_DIAGNOSIS_BEGIN: {
      return {
        ...state,
        cancelDiagnosis: null,
        cancelDiagnosisFetching: true,
        cancelDiagnosisError: false,
      };
    }
    case types.PUT_CANCEL_DIAGNOSIS_SUCCESS: {
      return {
        ...state,
        cancelDiagnosis: true,
        cancelDiagnosisFetching: false,
        cancelDiagnosisError: false,
      };
    }
    case types.PUT_CANCEL_DIAGNOSIS_FAILURE: {
      return {
        ...state,
        cancelDiagnosis: null,
        cancelDiagnosisFetching: false,
        cancelDiagnosisError: true,
      };
    }
    case types.RESET_CANCEL_DIAGNOSIS: {
      return {
        ...state,
        cancelDiagnosis: null,
        cancelDiagnosisFetching: false,
        cancelDiagnosisError: false,
        cancelDiagnosisModal: false,
      };
    }
    case types.VISIBILITY_CANCEL_DIAGNOSIS: {
      return {
        ...state,
        cancelDiagnosisModal: true,
      };
    }

    /* REITERATE DIAGNOSIS */
    case types.PUT_REITERATE_DIAGNOSIS_BEGIN: {
      return {
        ...state,
        reiterateDiagnosis: null,
        reiterateDiagnosisFetching: true,
        reiterateDiagnosisError: false,
      };
    }
    case types.PUT_REITERATE_DIAGNOSIS_SUCCESS: {
      return {
        ...state,
        reiterateDiagnosis: true,
        reiterateDiagnosisFetching: false,
        reiterateDiagnosisError: false,
      };
    }
    case types.PUT_REITERATE_DIAGNOSIS_FAILURE: {
      return {
        ...state,
        reiterateDiagnosis: null,
        reiterateDiagnosisFetching: false,
        reiterateDiagnosisError: true,
      };
    }
    case types.RESET_REITERATE_DIAGNOSIS: {
      return {
        ...state,
        reiterateDiagnosis: null,
        reiterateDiagnosisFetching: false,
        reiterateDiagnosisError: false,
      };
    }

    /* VALIDATE DIAGNOSIS */
    case types.PUT_VALIDATE_DIAGNOSIS_BEGIN: {
      return {
        ...state,
        validateDiagnosis: null,
        validateDiagnosisFetching: true,
        validateDiagnosisError: false,
      };
    }
    case types.PUT_VALIDATE_DIAGNOSIS_SUCCESS: {
      return {
        ...state,
        validateDiagnosis: payload,
        validateDiagnosisFetching: false,
        validateDiagnosisError: false,
      };
    }
    case types.PUT_VALIDATE_DIAGNOSIS_FAILURE: {
      return {
        ...state,
        validateDiagnosis: null,
        validateDiagnosisFetching: false,
        validateDiagnosisError: true,
      };
    }
    case types.PUT_NON_VALIDATE_DIAGNOSIS_SUCCESS: {
      const {
        id,
        nuevoContactoCreado,
        idLastDialogResponse,
        uuid,
        status,
        fin,
        controlErrores,
      } = payload;
      return {
        ...state,
        comunicationKey: id,
        validateDiagnosis: payload,
        validateDiagnosisFetching: false,
        validateDiagnosisError: false,
        newContact: nuevoContactoCreado,
        lastDialogIdReceived: idLastDialogResponse,
        pullingUUID: uuid,
        openDiagnosisBegins: false,
        openDiagnosisError: false,
        contLooping: {
          cont: 0,
          status: null,
        },
        status,
        fin,
        controlErrores,
        error: false,
      };
    }
    case types.RESET_VALIDATE_DIAGNOSIS: {
      return {
        ...state,
        validateDiagnosis: null,
        validateDiagnosisFetching: false,
        validateDiagnosisError: false,
      };
    }

    /* CONTINUE DIAGNOSIS */
    case types.PUT_CONTINUE_DIAGNOSIS_BEGIN: {
      return {
        ...state,
        continueDiagnosis: null,
        continueDiagnosisFetching: true,
        continueDiagnosisError: false,
      };
    }
    case types.PUT_CONTINUE_DIAGNOSIS_SUCCESS: {
      const {
        id,
        nuevoContactoCreado,
        idLastDialogResponse,
        uuid,
        status,
        fin,
        controlErrores,
      } = payload;
      return {
        ...state,
        comunicationKey: id,
        continueDiagnosis: payload,
        continueDiagnosisFetching: false,
        continueDiagnosisError: false,
        newContact: nuevoContactoCreado,
        lastDialogIdReceived: idLastDialogResponse,
        pullingUUID: uuid,
        openDiagnosisBegins: false,
        openDiagnosisError: false,
        contLooping: {
          cont: 0,
          status: null,
        },
        status,
        fin,
        controlErrores,
        error: false,
      };
    }
    case types.PUT_CONTINUE_DIAGNOSIS_FAILURE: {
      return {
        ...state,
        continueDiagnosis: null,
        continueDiagnosisFetching: false,
        continueDiagnosisError: true,
      };
    }
    case types.RESET_CONTINUE_DIAGNOSIS: {
      return {
        ...state,
        continueDiagnosis: null,
        continueDiagnosisFetching: false,
        continueDiagnosisError: false,
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
